export default "__VITE_ASSET__BI95I21u__"